import React, { useEffect, useState } from 'react';
import { api, fileUrl } from '../lib/api';
import { Upload, FileText, Image as ImageIcon, File } from 'lucide-react';

export default function Documents() {
  const [docs, setDocs] = useState([]);
  const [props, setProps] = useState([]);

  const load = () => Promise.all([api.get('/docs'), api.get('/properties')]).then(([d, p]) => { setDocs(d.data); setProps(p.data); });
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    const form = new FormData(); form.append('file', f); form.append('title', f.name); form.append('category', 'general');
    await api.post('/files/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } });
    load();
  };

  const propTitle = (id) => props.find(p=>p.id===id)?.title || 'Unassigned';

  return (
    <div className="py-6 max-w-6xl mx-auto space-y-6" data-testid="documents-page">
      <div className="flex items-center justify-between">
        <div>
          <div className="overline">Vault</div>
          <h1 className="font-serif text-4xl">Documents</h1>
        </div>
        <label className="btn-primary text-sm flex items-center gap-2 cursor-pointer" data-testid="upload-general-btn">
          <Upload size={14}/> Upload
          <input type="file" className="hidden" onChange={upload}/>
        </label>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {docs.map(d => (
          <a key={d.id} href={fileUrl(d.file_id)} target="_blank" rel="noreferrer" className="glass p-4 lift block">
            <div className="flex items-center gap-2 mb-2">
              {d.content_type?.startsWith('image') ? <ImageIcon size={18} className="text-slate-600"/>
                : d.content_type?.includes('pdf') ? <FileText size={18} className="text-slate-600"/>
                : <File size={18} className="text-slate-600"/>}
              <div className="overline text-[0.6rem]">{d.category}</div>
            </div>
            <div className="text-sm font-medium truncate">{d.title}</div>
            <div className="text-xs text-slate-500 truncate mt-1">{propTitle(d.property_id)}</div>
          </a>
        ))}
        {docs.length === 0 && <div className="col-span-4 text-center py-16 text-slate-400 glass">No documents yet.</div>}
      </div>
    </div>
  );
}
